<div>
  <p-dropdown styleClass='w-full' appendTo='body' [showClear]='true' [filter]='true' [autofocusFilter]='true'
              [options]='resources' [optionLabel]='optionLabel' [filterBy]='optionLabel' [optionValue]='property'
              [placeholder]='placeholder' [required]='required' [ngModel]='selectedResource' [disabled] = disabled
              (ngModelChange)='writeValue($event)' (onHide)='onHide()' #dropdown>
  </p-dropdown>
</div>
